import ViewColumnIcon from '@mui/icons-material/ViewColumn';

import {
  ToolbarButton,
  ColumnsPanelTrigger,
} from '@mui/x-data-grid';

export const ToolBarColumnToggler = () => {
	return (
		<ColumnsPanelTrigger render={<ToolbarButton />}>
			<ViewColumnIcon fontSize="small" />
		</ColumnsPanelTrigger>
	);
};

